import { io } from "socket.io-client";

class SocketioService {
  socket;

  constructor() {
    this.socket = null;
  }

  setupSocketConnection( token) {
    this.socket = io(process.env.VUE_APP_SERVER_ENDPOINT, {
      auth: {
        token,
      },
      transports: ["websocket"], // optional, ensures stable connection
    });

    this.socket.on("connect", () => {
      console.log("Connected to server:", this.socket.id);
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Disconnected:", reason);
    });
  }

  // Optionally update auth and reconnect
  reconnectWithAuth(token) {
    if (this.socket) {
      this.socket.auth = {token };
      this.socket.disconnect();
      this.socket.connect();
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      console.log("Socket disconnected manually");
    }
  }
}

export default new SocketioService();
